import { get, post } from "../api_helper";

const signin = async (data) => {
  const url = "signin";
  const response = await post(url, data);
  return response;
};

const signup = async (data) => {
  const url = "signup";
  const response = await post(url, data);
  return response;
};

const verifyEmail = async (token) => {
  const url = "verify-email?token=" + token;
  const response = await get(url);
  return response;
};

const forgotPassword = async (data) => {
  const url = "forget-password";
  const response = await post(url, data);
  return response;
};

const resetPassowrd = async (data) => {
  const url = "reset-password";
  const response = await post(url, data);
  return response;
};

const changePassword = async (data) => {
  const url = "change-password";
  const response = await post(url, data);
  return response;
};

export {
  signin,
  signup,
  verifyEmail,
  forgotPassword,
  resetPassowrd,
  changePassword,
};
